import { Button, Col, Form, Row, Modal } from "../../ui/ot";
import React, { useEffect, lazy, Suspense, useState } from "react";
import ClassifyStructureForm from "./ClassifyStructureForm";
import SortableTree from "../components/SortableTree";

const ClassifyStructureModal = ({
    axiosMode = "post",
    editTarget = "edit",
    propsForm,
    propsOpen = null,
    propsLoading = null,
    propsSetOpen = () => { },
    onFinish = () => { },
    customFormItems = () => { },
    initialTreeData = [],
    prefixTitle = "",
}) => {
    const axiosModelanguage = {
        post: "新增",
        patch: "編輯",
    };
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formReloadCount, setFormReloadCount] = useState(0);
    const [sortableData, setSortableData] = useState([]);
    const showModal = () => {
        setFormReloadCount((pre) => pre + 1);
        if (propsOpen === null) {
            setIsModalOpen(true);
        } else {
            propsSetOpen(true);
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        } else {
            propsSetOpen(false);
        }
    };

    const handleOk = () => {
        setLoading(true);
        if (editTarget === "edit") {
            if (propsForm) {
                propsForm.submit();
            } else if (form) {
                form.submit();
            }
        } else {
            //項目排序
            const finalData = ReorganizationData(sortableData);
            onFormFinish(finalData);
        }
    };

    const handleCancel = () => {
        closeModal();
    };
    const onFormFinish = (values) => {
        onFinish(values);
    };
    const ReorganizationData = (treeData) => {
        // 創建一個映射來跟踪每個節點的 ID 到其父節點的 ID
        const idToParentId = {};

        // 遞歸函數來處理每個節點，並計算深度和索引
        const processNode = (node, parentId, depth = 1) => {
            const { classify_structure_type_id, children } = node;

            // 更新當前節點的父節點 ID
            idToParentId[classify_structure_type_id] = parentId;

            // 設置深度（從 1 開始遞增）
            node.depth = depth;

            // 移除 property_json 元素
            delete node.property_json;

            // 設置子節點的索引（從 1 開始遞增）
            if (children && children.length > 0) {
                children.forEach((child, index) => {
                    child.index = index + 1; // 更新子節點的索引（從 1 開始）
                    processNode(child, classify_structure_type_id, depth + 1);
                });
            }
        };

        // 遍歷所有根節點
        treeData.forEach((node, index) => {
            node.index = index + 1; // 設置根節點的索引（從 1 開始）
            processNode(node, 0);
        });

        // 使用映射更新資料
        const UpdateData = (nodes) => {
            return nodes.map((node) => {
                const updatedNode = {
                    ...node,
                    classify_structure_type_id:
                        idToParentId[node.classify_structure_type_id] || 0,
                };

                // 移除 property_json 元素
                delete updatedNode.property_json;

                // 更新子節點
                if (updatedNode.children && updatedNode.children.length > 0) {
                    updatedNode.children = UpdateData(updatedNode.children);
                }

                return updatedNode;
            });
        };

        return UpdateData(treeData);
    };

    useEffect(() => {
        setFormReloadCount((pre) => pre + 1);
    }, [propsOpen]);
    return (
        <>
            {propsOpen === null && (
                <Button type="primary" onClick={showModal}>
                    {`${axiosModelanguage[axiosMode]}資料`}
                </Button>
            )}

            <Modal
                title={
                    editTarget === "edit"
                        ? `${axiosModelanguage[axiosMode]}項目`
                        : "項目排序"
                }
                open={propsOpen === null ? isModalOpen : propsOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                confirmLoading={propsLoading === null ? loading : propsLoading}
                maskClosable={false}
                width={1000}
                contentStyle={{
                    maxHeight: "90vh",
                    padding: 16
                }}
                okText={"儲存"}
                cancelText={"取消"}
            >
                <Row>
                    <Col span={24}>
                        {editTarget === "edit" ? (
                            <ClassifyStructureForm
                                formReloadCount={formReloadCount}
                                open={propsOpen === null ? isModalOpen : propsOpen}
                                axiosMode={axiosMode}
                                propsForm={propsForm ? propsForm : form}
                                onFormFinish={onFormFinish}
                                customFormItems={customFormItems}
                            />
                        ) : (
                            <>
                                {/* {console.log(initialTreeData)} */}
                                <SortableTree
                                    prefixTitle={prefixTitle}
                                    initialTreeData={initialTreeData}
                                    onChange={setSortableData}
                                />
                            </>
                            //   <SortableForm
                            //     formReloadCount={formReloadCount}
                            //     open={propsOpen === null ? isModalOpen : propsOpen}
                            //     axiosMode={axiosMode}
                            //     propsForm={propsForm ? propsForm : form}
                            //     onFormFinish={onFormFinish}
                            //     //   editcard={editcard}
                            //   />
                        )}
                    </Col>
                </Row>
            </Modal>
        </>
    );
};

export default ClassifyStructureModal;
